import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { getCurrentUserRole } from "../api/usersApi";

export const useAuth = () => {
  const { instance, accounts } = useMsal();
  const account = accounts[0];
  const [userInfo, setUserInfo] = useState(null);

  const getAccessToken = async () => {
    const response = await instance.acquireTokenSilent({
      ...loginRequest,
      account,
    });
    return response.accessToken;
  };

  useEffect(() => {
    const loadUserRole = async () => {
      if (!account) return;
      try {
        const token = await getAccessToken();
        const user = await getCurrentUserRole(account.username, token);
        setUserInfo(user);
      } catch (err) {
        console.error("❌ Failed to load user role:", err);
      }
    };
    loadUserRole();
  }, [account]);

  const signOut = () => instance.logoutRedirect();

  return {
    user: {
      name: account?.name,
      email: account?.username,
      ...userInfo, // adds role + location
    },
    getAccessToken,
    signOut,
  };
};
